export default class TravelServiceOrder {
  company_id = null;
  travelServiceOrderItems = [];
  status = null;
  additional_parameters = [];
  comment = null;
  created_at = null;
  created_by_id = null;
  id = null;
  project_id = null;
  external_customer_id = null;
}
